module.exports = __webpack_public_path__ + "img/session-thematique-4-bigApple.ceab493.jpg";